<template>
    <div class="d-flex align-items-center">
        <label class="me-2">Showing:</label>

        <select
                class="form-select mx-2"
                :style="{ width }"
                :value="currentValue"
                @change="onChange"
        >
            <option
                    v-for="option in options"
                    :key="option"
                    :value="option"
            >
                {{ option }}
            </option>
        </select>

        <label>entries</label>
    </div>
</template>

<script>
    export default {
        name: 'PerPageSelector',

        props: {
            value: {
                type: [Number, String],
                default: 20
            },
            options: {
                type: Array,
                default: () => [10, 20, 50, 100]
            },
            width: {
                type: String,
                default: '120px'
            }
        },

        computed: {
            currentValue() {
                return this.value;
            }
        },

        methods: {
            onChange(event) {
                const val = Number(event.target.value);
                this.$emit('input', val);
                this.$emit('change', val);
            }
        }
    };
</script>
